<template>
  <div class="artikl-unos forma-erp">

    <!-- Traka prati zbroj dok se tipka i drzi gumbe nadohvat. -->
    <div class="traka-ekrana mb-3">
      <div class="naslov">
        <span v-if="$store.state.editItem === 1">{{ lang.ItemEdit }}</span>
        <span v-else>{{ lang.ItemCreate }}</span>
      </div>
      <div class="brojka">
        <span>{{ lang.ItemSellingPrice }}</span>
        <b>{{ novac(item.itemPrice) }}</b>
      </div>
      <div class="brojka">
        <span>{{ lang.ItemPriceWithVAT }}</span>
        <b>{{ novac(item.itemPriceWithVAT) }}</b>
      </div>
      <div class="brojka">
        <span>{{ lang.ItemMargin }}</span>
        <b>{{ novac(item.itemMargin) }} %</b>
      </div>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="saving" indeterminate color="primary" size="22" class="mr-3"></v-progress-circular>
      <v-btn v-if="!newItemAround" small outlined color="primary" class="mr-2" @click="itemlist">
        {{ langC.Back }}
      </v-btn>
      <v-btn small class="green white--text" :disabled="!formIsValid" @click="register">
        <span v-if="$store.state.language == 'EN'">Register item</span>
        <span v-if="$store.state.language == 'HR'">Zapamti artikal</span>
      </v-btn>
    </div>

    <v-row no-gutters>
      <!-- ---------- lijevo: opisno ---------- -->
      <v-col cols="12" md="6" class="pr-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            {{ lang.ItemIdentification }}
            <span class="dodatak">{{ lang.ItemRequiredFields }}</span>
          </v-card-title>
          <v-card-text class="tijelo">
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2">
                <v-text-field :label="lang.ItemID" v-model="item.itemID" :rules="[required]" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field :label="lang.ItemName" v-model="item.itemName" :rules="[required]" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="8" class="pr-2">
                <v-text-field :label="lang.ItemNameShort" v-model="item.ItemNameShort" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field :label="lang.ItemUnit" v-model="item.itemUnit" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
            </v-row>

            <!-- Grupa: bira se iz sifrarnika, a gumbi rade sa sifrom. -->
            <v-row no-gutters align="center">
              <v-col cols="12" sm="7" class="pr-2" v-if="editGroup">
                <v-autocomplete
                  :items="privGroups"
                  v-model="selectGroup"
                  :label="lang.GroupId + ' *'"
                  item-text="GroupName"
                  item-value="id"
                  return-object
                  clearable
                  dense
                  outlined
                  hide-details
                  class="mb-3"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="7" class="pr-2" v-if="!editGroup">
                <v-text-field :label="lang.GroupName" v-model="item.GroupName" disabled dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" class="mb-3">
                <v-btn small outlined color="primary" class="mr-1" v-if="newItem" @click="findLatestInGroup">Zadnja šifra</v-btn>
                <v-btn small outlined color="primary" class="mr-1" v-if="editGroup && editItem" @click="updateGroup">Update</v-btn>
                <v-btn small outlined color="primary" v-if="!editGroup" @click="changeGroup">Change</v-btn>
              </v-col>
            </v-row>

            <v-autocomplete
              label="KPD (Klasus) šifra"
              :items="$store.state.klasus"
              v-model="selectKlasus"
              item-text="klasusFind"
              item-value="id"
              return-object
              @change="choosedKlasus(selectKlasus)"
              clearable
              dense
              outlined
              hide-details
              class="mb-3"
            ></v-autocomplete>

            <v-textarea :label="lang.ItemDescription" v-model="item.itemDescription" rows="2" dense outlined hide-details class="mb-3"></v-textarea>

            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2">
                <v-text-field :label="lang.ItemCode" v-model="item.ItemCode" dense outlined hide-details class="mb-1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" class="pr-2">
                <v-text-field :label="lang.ItemEANCode" v-model="item.ItemEANCode" dense outlined hide-details class="mb-1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field :label="lang.ItemBelongsToId" v-model="item.ItemBelongsToId" dense outlined hide-details class="mb-1"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.ItemFlags }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="kvacice">
              <v-checkbox v-model="item.itemService" :label="lang.ItemService" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="item.itemWeb" :label="lang.ItemWeb" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="item.itemNotActiv" :label="lang.ItemNotActiv" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="item.itemHideForever" :label="lang.ItemHideForever" hide-details dense class="mt-0 pt-0"></v-checkbox>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="slikeOtvorene = !slikeOtvorene">
            {{ lang.ItemPictures }}
            <span class="dodatak">{{ lang.ItemDefaultPictureMark }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ slikeOtvorene ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="slikeOtvorene">
            <ItemSlike :item="item" :prikazi-naslov="false" />
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="skladisteOtvoreno = !skladisteOtvoreno">
            {{ lang.ItemWarehouseDim }}
            <span class="dodatak">{{ lang.ItemWarehouseDimHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ skladisteOtvoreno ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="skladisteOtvoreno">
            <v-row no-gutters>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWarehouse" v-model="item.ItemWarehouse" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWarehouseRow" v-model="item.ItemWarehouseRow" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWarehouseShelf" v-model="item.ItemWarehouseShelf" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="6" sm="3"><v-text-field :label="lang.ItemWahrehouseFloor" v-model="item.ItemWahrehouseFloor" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWeightMeasure" v-model="item.ItemWeightMeasure" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWeight" v-model.number="item.ItemWeight" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemWarranty" v-model.number="item.ItemWarranty" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="6" sm="3"><v-text-field :label="lang.ItemSize" v-model.number="item.ItemSize" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemDimMeasure" v-model="item.ItemDimMeasure" dense outlined hide-details class="mb-1"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemDimLenght" v-model.number="item.ItemDimLenght" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field></v-col>
              <v-col cols="6" sm="3" class="pr-2"><v-text-field :label="lang.ItemDimHeight" v-model.number="item.ItemDimHeight" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field></v-col>
              <v-col cols="6" sm="3"><v-text-field :label="lang.ItemDimDepth" v-model.number="item.ItemDimDepth" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ---------- desno: novcano ---------- -->
      <v-col cols="12" md="6" class="pl-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.ItemPurchase }}</v-card-title>
          <v-card-text class="tijelo">
            <v-text-field :label="lang.ItemSuppCode" v-model="item.ItemSuppCode" dense outlined hide-details class="mb-3"></v-text-field>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2">
                <v-text-field :label="lang.ItemSuppBasePrice" v-model.number="item.itemSuppBasePrice" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="pr-2">
                <v-text-field :label="lang.ItemSuppDiscount" v-model.number="item.itemSuppDiscount" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  :label="lang.ItemSuppPrice"
                  :hint="lang.ItemCalculated"
                  persistent-hint
                  v-model.number="item.itemSuppPrice"
                  type="number"
                  readonly
                  dense
                  outlined
                  class="desno polje-racuna"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            {{ lang.Price }}
            <span class="dodatak">{{ lang.ItemHomeCurrencyShort }}</span>
          </v-card-title>
          <v-card-text class="tijelo">
            <!-- Umjesto olovke bez objasnjenja: sto se upisuje, a sto se racuna. -->
            <v-btn-toggle v-model="smjerCijene" mandatory dense class="mb-4 smjer">
              <v-btn small value="bez">{{ lang.ItemEnterPriceNoVAT }}</v-btn>
              <v-btn small value="sa">{{ lang.ItemEnterPriceWithVAT }}</v-btn>
            </v-btn-toggle>

            <v-row no-gutters>
              <v-col cols="12" sm="5" class="pr-2">
                <v-text-field
                  :label="lang.ItemPrice"
                  :hint="smjerCijene === 'sa' ? lang.ItemCalculated : ''"
                  :persistent-hint="smjerCijene === 'sa'"
                  :readonly="smjerCijene === 'sa'"
                  :class="['desno', 'mb-3', smjerCijene === 'sa' ? 'polje-racuna' : '']"
                  v-model.number="item.itemPrice"
                  type="number"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="4" class="pr-2">
                <v-select :label="lang.ItemHomeCurrency" :items="privitems" v-model="item.ItemHomeCurrency" dense outlined hide-details class="mb-3"></v-select>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field :label="lang.ItemVAT1Percentage" v-model.number="item.itemVAT1Percentage" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field :label="lang.ItemDirectDuty1" v-model.number="item.itemDirectDuty1" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :label="lang.ItemDirectDuty2" v-model.number="item.itemDirectDuty2" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field
                  :label="lang.ItemVAT1Amount"
                  :hint="lang.ItemCalculated"
                  persistent-hint
                  v-model.number="item.itemVAT1Amount"
                  type="number"
                  readonly
                  dense
                  outlined
                  class="desno polje-racuna"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="lang.ItemPriceWithVAT"
                  :hint="smjerCijene === 'bez' ? lang.ItemCalculated : ''"
                  :persistent-hint="smjerCijene === 'bez'"
                  :readonly="smjerCijene === 'bez'"
                  :class="['desno', smjerCijene === 'bez' ? 'polje-racuna' : '']"
                  v-model.number="item.itemPriceWithVAT"
                  type="number"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Sidrena (dodatna) cijena - NN 101/2026, obveza od 1.10.2026.
                 Uz maloprodajnu cijenu mora stajati i cijena koja je za isti
                 artikl vrijedila na referentni datum. Prazno polje znaci "nije
                 utvrdjena" i to nije isto sto i 0,00, pa se ne postavlja samo
                 od sebe - puni se gumbom ili skupno na ekranu Sidrene cijene. -->
            <v-row no-gutters class="mt-4 sidrena">
              <v-col cols="12" sm="5" class="pr-2">
                <v-text-field
                  label="Sidrena cijena (s PDV-om)"
                  v-model="item.sidrenaCijena"
                  type="number"
                  placeholder="nije utvrđena"
                  persistent-placeholder
                  dense
                  outlined
                  hide-details
                  class="mb-3 desno"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="4" class="pr-2">
                <v-text-field
                  label="Na dan"
                  v-model="item.sidrenaCijenaDatum"
                  type="date"
                  dense
                  outlined
                  hide-details
                  class="mb-3"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-btn small outlined color="primary" class="mb-3" @click="napuniSidrenu">
                  Iz cjenika
                </v-btn>
              </v-col>
              <v-col cols="12">
                <div class="sitno">
                  Cijena koja je za ovaj artikl vrijedila na referentni datum (10.09.2026., za FMCG 02.05.2025.),
                  bez akcija i posebnih oblika prodaje. Novi artikli uvedeni poslije toga datuma ostaju prazni.
                </div>
              </v-col>
            </v-row>

            <!-- Kako je cijena nastala, odozgo prema dolje. -->
            <div class="obracun mt-4">
              <table>
                <tr>
                  <td>{{ lang.ItemSuppPrice }}</td>
                  <td>{{ novac(item.itemSuppPrice) }}</td>
                </tr>
                <tr>
                  <td>{{ lang.ItemMargin }}</td>
                  <td>{{ novac(item.itemMargin) }} %</td>
                </tr>
                <tr class="zbroj">
                  <td>{{ lang.ItemPriceNoVATLabel }}</td>
                  <td>{{ novac(item.itemPrice) }}</td>
                </tr>
                <tr>
                  <td>{{ lang.ItemVAT1Percentage }} {{ novac(item.itemVAT1Percentage) }} %</td>
                  <td>{{ novac(pdvIznos) }}</td>
                </tr>
                <tr class="zbroj">
                  <td>{{ lang.ItemPriceWithVAT }}</td>
                  <td>{{ novac(item.itemPriceWithVAT) }}</td>
                </tr>
              </table>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="marzaOtvorena = !marzaOtvorena">
            {{ lang.ItemMarginDiscounts }}
            <span class="dodatak">{{ lang.ItemMaxDiscountHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ marzaOtvorena ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="marzaOtvorena">
            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field
                  :label="lang.ItemMargin"
                  :hint="lang.ItemCalculated"
                  persistent-hint
                  v-model.number="item.itemMargin"
                  type="number"
                  readonly
                  dense
                  outlined
                  class="desno polje-racuna"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="lang.ItemMaxDiscount"
                  :hint="lang.ItemMaxDiscountHint"
                  persistent-hint
                  v-model.number="item.itemMaxDiscount"
                  type="number"
                  readonly
                  dense
                  outlined
                  class="desno polje-racuna"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="podnaslov mt-4">
              {{ lang.ItemQtyDiscounts }}
              <span class="dodatak">{{ lang.ItemQtyDiscountsHint }}</span>
            </div>
            <v-row no-gutters v-for="broj in [1, 2, 3]" :key="broj">
              <v-col cols="6" class="pr-2">
                <v-text-field
                  :label="lang.ItemQty + ' ' + broj"
                  v-model.number="item['itemDiscountAmount' + broj]"
                  type="number"
                  dense
                  outlined
                  hide-details
                  class="mb-2 desno"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="lang['ItemDiscountPercentage' + broj]"
                  v-model.number="item['itemDiscountPercentage' + broj]"
                  type="number"
                  dense
                  outlined
                  hide-details
                  class="mb-2 desno"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="izvozOtvoreno = !izvozOtvoreno">
            {{ lang.PriceExp }}
            <span class="dodatak">{{ lang.ItemPriceExpHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ izvozOtvoreno ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="izvozOtvoreno">
            <v-row no-gutters>
              <v-col cols="12" sm="5" class="pr-2">
                <v-text-field :label="lang.ItemForePrice" v-model.number="item.itemForePrice" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
              <v-col cols="6" sm="4" class="pr-2">
                <v-select :label="lang.ItemForeignCurrency" :items="privitems" v-model="item.ItemForeignCurrency" dense outlined hide-details class="mb-3"></v-select>
              </v-col>
              <v-col cols="6" sm="3">
                <v-text-field :label="lang.ItemExRate" v-model.number="item.ItemExRate" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field :label="lang.ItemForeVAT1Percentage" v-model.number="item.ItemForeVAT1Percentage" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :label="lang.ItemForeVAT1Amount" v-model.number="item.itemForeVAT1Amount" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field :label="lang.ItemForeDirectDuty1" v-model.number="item.itemForeDirectDuty1" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field :label="lang.ItemForeDirectDuty2" v-model.number="item.itemForeDirectDuty2" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field>
              </v-col>
            </v-row>
            <v-text-field :label="lang.ItemForePriceWithVAT" v-model.number="item.itemForePriceWithVAT" type="number" dense outlined hide-details class="mb-1 desno"></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
      {{ text }}
      <v-btn color="pink" text @click="snackbar = false">{{ langC.Close }}</v-btn>
    </v-snackbar>

  </div>
</template>

<script>

//import GroupService from '@/services/GroupService'
import ItemService from '@/services/ItemService'
import moneyFormat from '@/snippets/moneyFormat'
import maxPopust from '@/snippets/maxPopust'
import ItemSlike from './ItemSlike'
import DocumentDetailService from '@/services/DocumentDetailService'
import langEn from './itemDescEn'
import langHr from './itemDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import { newUpdates, testLastUpdate } from '../../services/TestLastUpdate'
import { round, parseNum } from '@/snippets/allSnippets'

export default {
  name: 'itemcreate',
  $validates: true,
  data () {
    return {
      saving: false,
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      lang: {},
      langC: {},
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      // Sto korisnik upisuje: 'bez' = cijenu bez PDV-a, 'sa' = cijenu s PDV-om.
      // Ono drugo se onda racuna. Prije je to bila olovka bez objasnjenja.
      smjerCijene: 'bez',
      skladisteOtvoreno: false,
      izvozOtvoreno: false,
      slikeOtvorene: false,
      marzaOtvorena: false,
      samoZaProbu: 0,
      item: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 0,
        email: '',
        GroupId: 0,
        GroupName: '',
        itemID: '',
        itemName: '',
        ItemNameShort: '',
        ItemCode: '',
        ItemEANCode: '',
        itemGroup: '',
        itemDescription: '',
        itemUnit: '',
        ItemSize: '',
        ItemWeight: 0,
        ItemWeightMeasure: '',
        ItemDimMeasure: '',
        ItemDimLenght: 0,
        ItemDimHeight: 0,
        ItemDimDepth: 0,
        ItemWarehouse: '',
        ItemWarehouseRow: '',
        ItemWarehouseShelf: '',
        ItemWahrehouseFloor: '',
        ItemPicture1: '',
        ItemPicture2: '',
        ItemPicture3: '',
        ItemPicture4: '',
        ItemPicture5: '',
        ItemPicture6: '',
        ItemPicture7: '',
        ItemDefaultPicture: null,
        ItemBelongsToId: 0,
        itemService: false,
        itemWeb: false,
        itemNotActiv: false,
        itemHideForever: false,
        ItemHomeCurrency: 'EUR',
        ItemForeignCurrency: 'EUR',
        ItemExRate: 0,
        itemSuppPrice: 0,
        itemSuppBasePrice: 0,
        itemSuppDiscount: 0,
        ItemSuppCode: '',
        ItemSupppartnerName : '',
        ItemSupppartnerID: 0,
        ItemSupppartnerVATID: '',
        ItemSuppDate : null,
        ItemSuppDoc : '',
        ItemSuppDocNr : '',
        itemMargin: 0,
        itemMaxDiscount: 0,
        itemPrice: 0,
        itemVAT1Percentage: 25,
        itemVAT1Amount: 0,
        itemVAT2Percentage: 0,
        itemVAT2Amount: 0,
        itemDirectDuty1: 0,
        itemDirectDuty2: 0,
        itemPriceWithVAT: 0,
        // Prazno, ne 0: nova stavka jos nema utvrdjenu sidrenu cijenu.
        sidrenaCijena: null,
        sidrenaCijenaDatum: '2026-09-10',
        itemForePrice: 0,
        itemForeVAT1Percentage: 0,
        itemForeVAT1Amount: 0,
        itemForeVAT2Percentage: 0,
        itemForeVAT2Amount: 0,
        itemForeDirectDuty1: 0,
        itemForeDirectDuty2: 0,
        itemForePriceWithVAT: 0,
        itemDiscountAmount1: 0,
        itemDiscountPercentage1: 0,
        itemDiscountAmount2: 0,
        itemDiscountPercentage2: 0,
        itemDiscountAmount3: 0,
        itemDiscountPercentage4: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
        LastUpdateBy: '',
        PotpunaSifra: ''
      },
      error: null,
      localError: false,
      privitems: [
        { text: 'EUR', value: 'EUR' },
        { text: 'Kn', value: 'Kn' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' }
      ],
      privGroups: [],
      selectGroup: {},
      mainQuery: {
        CompanyId: 1
      },
      required: (value) => !!value || 'Required.',
      calcNoVAT: false,
      calcVAT: false,
      itemsLoc: [],
      haveItem: {},
      newItemAround: false,
      editGroup: true,
      origGroup: null,
      editItem: false,
      resData: {},
      newItem: false,
      selectKlasus: {}
    }
  },
  components: {
    ItemSlike,
  },
  async mounted () {
    try {
      if (this.$store.state.language === 'EN') {
        this.lang = langEn
        this.langC = commEn
      }
      if (this.$store.state.language === 'HR') {
        this.lang = langHr
        this.langC = commHr
      }
      if (this.$store.state.companyid) {
        this.item.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      if (this.$store.state.groupStore) {
        //this.privGroups = (await GroupService.choose(this.mainQuery)).data.groups
        this.privGroups = this.$store.state.groupStore
      }
      console.log('ITEM CREATE this.$store.state.editItem: ', this.$store.state.editItem);
      if (this.$store.state.editItem === 0) {     
        this.newItem = true
        this.item.ItemHomeCurrency = this.$store.state.businessYear && this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR'
        this.item.ItemForeignCurrency = 'EUR'
        this.item.ItemExRate = this.$store.getters.NeedDefExRate
      }
      let saveItFromXML = false
      if (this.$store.state.itemFromXML && Object.keys(this.$store.state.itemFromXML).length > 0) {
        saveItFromXML = true
        console.log('kopiram kaj imam u novi ', this.$store.state.itemFromXML )
        this.item = {...this.$store.state.itemFromXML}
      }
      if (this.$store.state.editItem === 1 && !saveItFromXML) {
        const dbItem = await ItemService.show(this.$store.state.itemid)
        this.item = dbItem.data.item
        this.item.ItemHomeCurrency = this.$store.state.businessYear && this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR'
        this.item.ItemForeignCurrency = 'EUR'
        this.item.ItemExRate = this.$store.getters.NeedDefExRate
        this.origGroup = this.item.GroupId ? this.item.GroupId : null
        this.editGroup = false
        this.editItem = true
        const result2 = this.$store.state.klasus.filter(element => element.PotpunaSifra === this.item.PotpunaSifra)
        if (result2[0]) {
          this.selectKlasus = result2[0]
        }
      }
      //this.newItemAround = this.$store.state.newItemAround ? this.$store.state.newItemAround : false

    } catch (error) {
      // eslint-disable-next-line
      console.log('error ', error)
    }
  },
  computed: {
    pdvIznos () {
      return this.pNum(this.item.itemPrice) * this.pNum(this.item.itemVAT1Percentage) / 100
    },

    formIsValid () {
      return this.item.GroupId !== '' &&
        this.item.itemID !== '' &&
        this.item.itemName !== ''
    }
  },
  methods: {
    pNum (vrijednost) {
      return parseFloat(vrijednost) || 0
    },
    novac (vrijednost) {
      return moneyFormat(this.pNum(vrijednost))
    },

    choosedKlasus (choosedK) {
      if (choosedK) {
        const result = this.$store.state.klasus.filter(element => element.id === choosedK.id)
        if (result[0]) {
          const res = result[0]
          this.item.PotpunaSifra = res.PotpunaSifra
          this.selectKlasus = res
        } else {
          this.text = 'Nije odabran ispravn kod!'
          this.color = 'red'
          this.snackbar = true
        }
      } else {
        this.item.PotpunaSifra = null
      }     
    },
    changeGroup() {
      this.editGroup = true
    },
    async findLatestInGroup() {
      let latestID = 0
      const allItems = await ItemService.index(this.mainQuery)
      if (allItems && allItems.data && !allItems.data.errors) {
        if (this.selectGroup && this.selectGroup.id) {
          const groupItems = allItems.data.items.filter(group => group.GroupId === this.selectGroup.id)
          if (groupItems) {
            groupItems.map(gitem => {
              if (parseInt(gitem.itemID) > latestID) {
                latestID = parseInt(gitem.itemID)
              }
            })
          }
        }
        if (!this.selectGroup.id && !allItems.data.errors) {
          allItems.data.items.map(gitem => {
            if (parseInt(gitem.itemID) > latestID) {
              latestID = parseInt(gitem.itemID)
            }
          })
        }
      }
      latestID += 1
      this.item.itemID = latestID
    },
    async updateGroup() {
      this.editGroup = false
      // update documents to new group
      this.mainQuery.CompanyId = this.$store.state.companyid
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2021
      if (this.selectGroup.id) {
        this.mainQuery.GroupId = this.selectGroup.id
        this.mainQuery.itemGroup = this.selectGroup.GroupName
        this.item.GroupId = this.selectGroup.id
        this.item.GroupName = this.selectGroup.GroupName
      }
      if (this.item.itemID) {
        this.mainQuery.itemID = this.item.itemID
      }
      if (this.$store.state.editItem === 1 && this.origGroup) {
        const newGroupUp = {}
        newGroupUp.id = this.item.id
        newGroupUp.GroupId = this.selectGroup.id
        newGroupUp.GroupName = this.selectGroup.GroupName
        await ItemService.put(newGroupUp).then(async(res)=>{
          this.resData = res.data
          await DocumentDetailService.updateitems(this.mainQuery)
          .then(res => {
            this.haveItem = res.item
            this.text = 'OK! Group is updated'
            this.color = 'green'
            this.snackbar = true
          })
          .catch(err => {
            this.error = err
            this.localError = false
            this.text = 'Error!' + err
            this.color = 'red'
            this.snackbar = true
          })
        })
        .catch(err=> {
          this.error = err
          this.localError = false
          this.text = 'Error!' + err
          this.color = 'red'
          this.snackbar = true
        })
        this.itemsLoc = (await ItemService.index(this.mainQuery)).data.items
        if (this.itemsLoc) {
          this.$store.dispatch('setActivItems', this.itemsLoc)
        }
      }
    },
    async register () {
      try {
        if (this.$store.state.user.id) {
          this.item.UserId = this.$store.state.user.id
        }
        if (this.$store.state.user.email) {
          this.item.email = this.$store.state.user.email
          this.item.LastUpdateBy = this.$store.state.user.email
        }
        if (this.$store.state.companyid) {
          this.item.CompanyId = this.$store.state.companyid
        }
        if (this.$store.state.companyName) {
          this.item.CompanyNameDatabase = this.$store.state.companyName
        }
        this.item.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020

        // Prazno polje mora u bazu otici kao NULL. Prazan tekst bi Postgres
        // odbio na numeric stupcu, a 0 bi znacila da je artikl na referentni
        // datum bio besplatan - a znaci samo da cijena nije utvrdjena.
        if (this.item.sidrenaCijena === '' || this.item.sidrenaCijena === undefined) {
          this.item.sidrenaCijena = null
        }
        if (this.item.sidrenaCijena !== null) {
          this.item.sidrenaCijena = parseFloat(this.item.sidrenaCijena)
          if (isNaN(this.item.sidrenaCijena)) { this.item.sidrenaCijena = null }
        }
        if (!this.item.sidrenaCijenaDatum) { this.item.sidrenaCijenaDatum = null }

        if (this.selectGroup.id) {
          this.item.GroupId = this.selectGroup.id
          this.item.itemGroup = this.selectGroup.id
        }
        if (this.selectGroup.GroupName) {
          this.item.GroupName = this.selectGroup.GroupName
        }

        this.localError = false
        if (this.$store.state.companyid) {
          this.mainQuery.CompanyId = await this.$store.state.companyid
        }
        if (this.item.itemID) {
          this.mainQuery.itemID = this.item.itemID
        }
        let saveItFromXML = false
        if (this.$store.state.itemFromXML && Object.keys(this.$store.state.itemFromXML).length > 0) {
          saveItFromXML = true
        }
        this.saving = true
        this.localError = true
        
        // new item from document
        if (this.$store.state.newItemAround === true) {
          console.log('>>>Item create dodajem novi ', this.$store.state.newItemAround )
            let addIt = true
            await ItemService.choose(this.mainQuery)            
              .then(res => {
                addIt = false
                this.haveItem = res.item
                this.localError = true
                this.text = 'ERROR! Item ID already exist!! Sifra vec postoji!!'
                this.color = 'red'
                this.snackbar = true
                return
              })
              .catch(err => {
                this.error = err.data
                this.localError = false
              })
            if (addIt) {
              const res = await ItemService.post(this.item)
              if (res?.data?.item) {
                this.$store.dispatch('setSelectedItemId', res.data.item)
              }
              this.text = this.lang.Saved
              this.color = 'green'
              this.snackbar = true
              await newUpdates(1)
              await testLastUpdate()
            }
        }

        // normal operation 
        if (this.$store.state.newItemAround === false) {
          
            console.log('>>>Item create stari postupak ', this.$store.state.newItemAround )
            this.localError = false
            if (this.$store.state.editItem === 0) {
              
                await ItemService.choose(this.mainQuery)            
                  .then(res => {
                    addIt = false
                    this.haveItem = res.item
                    this.localError = true
                    this.text = 'ERROR! Item ID already exist!! Sifra vec postoji!!'
                    this.color = 'red'
                    this.snackbar = true
                    return
                  })
                  .catch(err => {
                    this.error = err.data
                    this.localError = false
                  })
            }
            if (this.localError === false && this.$store.state.editItem === 0) {
              const res = await ItemService.post(this.item)
              if (res?.data?.item) {
                this.$store.dispatch('setSelectedItemId', res.data.item)
              }
              console.log('2.1 krivo ')
              this.text = this.lang.Saved
              this.color = 'green'
              this.snackbar = true
              await newUpdates(1)
              await testLastUpdate()

            }
            if (this.$store.state.editItem === 1) {
              await ItemService.put(this.item)
              this.text = this.lang.Saved
              this.color = 'green'
              this.snackbar = true
              await newUpdates(1)
              await testLastUpdate()
            }
        }
        this.$store.dispatch('setnewItemAround', false)
        this.saving = false
        
        // this.itemsLoc = (await ItemService.index(this.mainQuery)).data.items
        // if (this.itemsLoc) {
        //   this.$store.dispatch('setActivItems', this.itemsLoc)
        // }
        // if (this.newItemAround) {
        //   this.$store.dispatch('setSelectedItemId', this.item)
        // }
        // this.$router.push({
        //   name: 'item'
        // })
      } catch (error) {
        this.error = 'Greska u konekciji na bazu'
      }
    },
    close () {
      this.show = false
    },
    async itemlist () {
      try {
        if (this.$store.state.editItem === 1) {
          this.$store.dispatch('seteditItem', 0)
        }
        await this.$router.push({
          name: 'item'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    // Sidrena cijena iz vazeceg cjenika. Pise se samo na zahtjev, jer je to
    // izjava "ovoliko je artikl stajao na referentni datum" - ne smije se
    // popuniti sama od sebe svaki put kad se cijena promijeni.
    napuniSidrenu () {
      const cijena = parseFloat(this.item.itemPriceWithVAT)
      if (!cijena && cijena !== 0) { return }
      if (this.item.sidrenaCijena !== null && this.item.sidrenaCijena !== '' &&
          !confirm('Sidrena cijena je već upisana (' + this.item.sidrenaCijena + '). Prepisati je današnjom maloprodajnom cijenom?')) {
        return
      }
      this.item.sidrenaCijena = parseFloat(cijena.toFixed(2))
      if (!this.item.sidrenaCijenaDatum) { this.item.sidrenaCijenaDatum = '2026-09-10' }
    },
    initValue () {
      this.item.itemPrice = this.item.itemPrice ? parseFloat(this.item.itemPrice) : 0
      this.item.itemVAT1Percentage = this.item.itemVAT1Percentage ? parseFloat(this.item.itemVAT1Percentage) : 0
      this.item.itemDirectDuty1 = this.item.itemDirectDuty1 ? parseFloat(this.item.itemDirectDuty1) : 0
      this.item.itemDirectDuty2 = this.item.itemDirectDuty2 ? parseFloat(this.item.itemDirectDuty2) : 0
      this.item.itemPriceWithVAT = this.item.itemPriceWithVAT ? parseFloat(this.item.itemPriceWithVAT) : 0
    },
    calculatePrice () {
      this.initValue()
      this.item.itemPriceWithVAT = this.item.itemPrice + this.item.itemDirectDuty1 + this.item.itemDirectDuty2 + (this.item.itemPrice * (this.item.itemVAT1Percentage / 100))
      this.item.itemPriceWithVAT = this.item.itemPriceWithVAT ? parseFloat((this.item.itemPriceWithVAT).toFixed(2)) : 0
      // Iznos PDV-a se dosad nije popunjavao, pa je polje u sifrarniku stajalo prazno.
      this.item.itemVAT1Amount = parseFloat((this.item.itemPrice * (this.item.itemVAT1Percentage / 100)).toFixed(2))
    },
    calculatePrice2 () {
      this.initValue()
      if (this.item.itemPriceWithVAT !== 0) {
        const itemNoDuty = this.item.itemPriceWithVAT - this.item.itemDirectDuty1 - this.item.itemDirectDuty2      
        this.item.itemPrice = parseFloat((itemNoDuty / (1 + (this.item.itemVAT1Percentage / 100))).toFixed(2))
        this.item.itemVAT1Amount = parseFloat((this.item.itemPrice * (this.item.itemVAT1Percentage / 100)).toFixed(2))
      }      
    },
    calculateMargin() {
      if (!this.item.itemSuppBasePrice) {
        this.item.itemSuppBasePrice = 0
      }
      if (!this.item.itemSuppDiscount) {
        this.item.itemSuppDiscount = 0
      }
      this.item.itemSuppPrice  = this.item.itemSuppBasePrice - (this.item.itemSuppBasePrice * (this.item.itemSuppDiscount/100))
      this.item.itemPrice = round((this.item.itemPrice ), 2)
      const itemNoDuty = this.item.itemPriceWithVAT - this.item.itemDirectDuty1 - this.item.itemDirectDuty2
      // Marza se racuna od onoga sto je stvarno placeno - nabavne s popustom.
      const marginAmount = this.item.itemPrice - this.item.itemSuppPrice
      if (this.item.itemSuppPrice !== 0) {
        this.item.itemMargin = round(marginAmount / (this.item.itemSuppPrice / 100), 2)
      }
      this.item.itemMaxDiscount = maxPopust(this.item.itemPrice, this.item.itemSuppPrice)
    }
  },
  watch: {
    'item.itemPrice' () {
      if (typeof this.item?.itemPrice === 'number' && this.smjerCijene === 'bez') {
        this.calculatePrice()
      }
      if (typeof this.item?.itemPrice === 'number') {
        this.calculateMargin()
      }
    },
    'item.itemVAT1Percentage' () {
      if (typeof this.item?.itemVAT1Percentage !== 'number') { return }
      if (this.smjerCijene === 'bez') {
        this.calculatePrice()
      } else {
        this.calculatePrice2()
      }
      this.calculateMargin()
    },
    'item.itemSuppBasePrice' () {
      if (typeof this.item?.itemSuppBasePrice === 'number') {
        this.calculateMargin()
      }
    },
    'item.itemPriceWithVAT' () {
      // Racuna unatrag samo kad korisnik doista upisuje cijenu s PDV-om.
      if (typeof this.item?.itemPriceWithVAT === 'number' && this.smjerCijene === 'sa') {
        this.calculatePrice2()
        this.calculateMargin()
      }
    },
    smjerCijene () {
      // Prebacivanje smjera odmah uskladi ono polje koje je sad izracunato.
      if (this.smjerCijene === 'bez') {
        this.calculatePrice()
      } else {
        this.calculatePrice2()
      }
      this.calculateMargin()
    },
    'item.itemSuppPrice' () {
      if (typeof this.item?.itemSuppPrice === 'number') {
        this.calculateMargin()
      }
    },
    'item.itemSuppDiscount' () {
      if (typeof this.item?.itemSuppDiscount === 'number') {
        this.calculateMargin()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.artikl-unos { padding: 8px 12px; }

/* Sidrena cijena se odvaja crtom: nije dio obracuna iznad nje, nego podatak o
   proslosti koji se ne racuna ni iz cega. */
.artikl-unos .sidrena {
  border-top: 1px dashed #c8d3de;
  padding-top: 12px;
}
.artikl-unos .sidrena .sitno {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
}

/* traka prati zbroj dok se tipka */

/* kartice */
.artikl-unos .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 8px;
}
.artikl-unos .naslov-kartice .dodatak,
.artikl-unos .podnaslov .dodatak {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.artikl-unos .naslov-kartice.sklopiva {
  cursor: pointer;
}
.artikl-unos .tijelo {
  padding: 14px 16px 16px;
}
.artikl-unos .podnaslov {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.75);
  margin-bottom: 8px;
}

/* polje koje sustav racuna sam - da se ne mijesa s onim sto se upisuje */
.artikl-unos .polje-racuna >>> .v-input__slot {
  background: #f5f7f9;
}
.artikl-unos .polje-racuna >>> fieldset {
  border-style: dashed;
}
.artikl-unos .polje-racuna >>> input {
  color: rgba(0, 0, 0, 0.7);
}
.artikl-unos .polje-racuna >>> .v-messages__message {
  font-style: italic;
  color: #90a4ae;
}
.artikl-unos .desno >>> input {
  text-align: right;
}

/* izbor smjera racuna */
.artikl-unos .smjer >>> .v-btn {
  text-transform: none;
  letter-spacing: 0;
  font-size: 13px;
}

/* kako je cijena nastala */
.artikl-unos .obracun {
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 10px 12px;
  font-variant-numeric: tabular-nums;
}
.artikl-unos .obracun table {
  width: 100%;
  border-collapse: collapse;
}
.artikl-unos .obracun td {
  padding: 4px 0;
  font-size: 14px;
}
.artikl-unos .obracun td:last-child {
  text-align: right;
  font-weight: 500;
  white-space: nowrap;
  padding-left: 12px;
}
.artikl-unos .obracun tr.zbroj td {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-weight: 700;
  font-size: 16px;
  padding-top: 7px;
}
.artikl-unos .obracun tr.zbroj td:last-child {
  color: #1565c0;
}

.artikl-unos .kvacice {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
}
</style>
